module.exports = __webpack_public_path__ + "img/20.3c4935b8.png";